import draftToHtml from 'draftjs-to-html';
import parse from 'html-react-parser';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isEnglish } from '../_helpers';
import { apiConstants } from '../_constants';
import { answerService } from '../_services/answer.service';

export const MockTestSingle = ({ question, totalQuestions, handleNext, handlePrev, attempt }) => {
  const navigate = useNavigate();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [isLoading] = useState(false);
  const [selectedAnswer, setSelectedAnswer] = useState(-1);

  useEffect(() => {
    if (question?.answer?.option_index || question?.answer?.option_index == 0) {
      setSelectedAnswer(question?.answer?.option_index);
    } else {
      setSelectedAnswer(-1);
    }
  }, [question]);
  // const renderText = (text, inlineStyleRanges) => {
  //   return inlineStyleRanges.reduce((acc, styleRange) => {
  //     const style = {};
  //     style[styleRange.style] = true;
  //     return <div style={style}>{acc}</div>;
  //   }, text);
  // };
  // convert draft to text initial call
  // const ContentRenderer = (contentState) => {
  //   const renderedBlocks = contentState?.blocks.map((block) =>
  //     renderText(block.text, block.inlineStyleRanges),
  //   );
  //   return renderedBlocks;
  // };

  const handleAnswer = (option, questionId, optionIndex) => {
    setSelectedAnswer(optionIndex);

    let userAnsweredOption = option?.option; // user answered option
    let correctAnswer = Object.keys(question?.answers)[0] == optionIndex;
    // setIsAnswerLoading(true);

    let ans = {};
    if (question?.answer) {
      ans = question.answer;
      ans.answer = userAnsweredOption;
      ans.is_correct = correctAnswer;
      ans.option_index = optionIndex;
      ans.updated_at = moment().valueOf();
    } else {
      ans = {
        answer: userAnsweredOption,
        is_correct: correctAnswer,
        attempt: attempt ? attempt : 1,
        mode: 3,
        order: question?.index,
        question_id: questionId,
        option_index: optionIndex,
        mocktest_id: question.mocktest_id,
        created_at: moment().valueOf(),
        updated_at: moment().valueOf(),
      };
      if (question.topic_id) {
        ans['topic_id'] = question.topic_id;
      } else {
        ans['mocktest_id'] = question.mocktest_id;
      }
    }
    answerService.answerAdd(ans).then(
      (res) => {
        // setIsAnswerLoading(false);
        question.answer = res.data;
        // setQuestions({ ...ques, answer: res.data });
      },
      (err) => {
        // setIsAnswerLoading(false);
        console.error(err, 'answerAddError');
      },
    );
  };
  return (
    <div className='qna'>
      <div className='d-flex justify-content-end'>
        <div
          className='exitbtn'
          onClick={() => {
            setShowConfirmationModal(true);
          }}
        >
          End Test
        </div>
      </div>
      <div className='questionindex'>
        <div className='questionno mt-4 mb-4'>{`Question ${
          question?.index + 1
        } / ${totalQuestions}`}</div>
        <div className='progressbarcontainer'>
          <div
            className='examprogress'
            style={{ width: (100 / totalQuestions) * (question?.index + 1) + '%' }}
          />
        </div>
        {question?.image_question ? (
          <img src={apiConstants.imgUrl + question?.image_question} className='imagequestion' />
        ) : (
          <div className={'question ' + (isEnglish(question?.question) ? 'ltrtext' : 'rtltext')}>
            {/* {ContentRenderer(question?.question)} */}
            {parse(draftToHtml(question?.question), {
              decodeEntities: false,
            })}
          </div>
        )}
        <div className='optionscontainer'>
          {question?.options?.map((opt, index) => {
            const isOptEnglish = isEnglish(opt.option);
            return (
              <div
                className={
                  'optionbox ' +
                  (selectedAnswer == index ? 'selectedans ' : '') +
                  (isOptEnglish ? 'englishopt' : '')
                }
                key={index}
                onClick={() => {
                  if (selectedAnswer == -1) handleAnswer(opt, question._id, index);
                }}
              >
                {opt?.option}
              </div>
            );
          })}

          {/* {question?.answers?.description && selectedAnswer != -1 && mode == 2 && (
            <div className='hint d-flex align-items-center'>
              <img src='/img/hinticon.png' className='hinticon' />
              <div className='hintdesc'>{item?.answers?.description}</div>
              <img src={apiConstants.imgUrl + item?.answers?.image} className='hintimg' />
            </div>
          )} */}
        </div>
        <div className='actionscontainer'>
          <div className='actionscontainer gap-2'>
            {isLoading && <img src='/img/Loadingicon.gif' className='examloading' />}
            <div
              className={'nextprevbtn ' + (isLoading || selectedAnswer == -1 ? 'disabled' : '')}
              onClick={() => {
                !isLoading &&
                  selectedAnswer !== -1 &&
                  handleNext(question.NextId, question.answer.order, question._id);
              }}
            >
              Next
            </div>
            <div
              className={'nextprevbtn prevbtn ' + (isLoading ? 'disabled' : '')}
              onClick={() => {
                !isLoading &&
                  question?.index !== 0 &&
                  handlePrev(question.PrevId, question.index, question._id);
              }}
            >
              Prev
            </div>
          </div>
        </div>
      </div>

      {showConfirmationModal && (
        <div className='modal ' style={{ display: 'block', background: ' rgb(10 11 11 / 50%)' }}>
          <div className='modal-dialog' style={{ maxWidth: 650 }}>
            <div className='modal-content'>
              <div className='modal-header justify-content-center' style={{ color: '#0c859d' }}>
                <div className='modal-header-content'>
                  <h4 className='card-title'>Are You Sure?</h4>
                </div>
                <div className='close' style={{ marginTop: -6 }}>
                  <a onClick={() => setShowConfirmationModal(false)}>&times;</a>
                </div>
              </div>
              <div className='modal-body' style={{ textAlign: 'center' }}>
                <div className='modalcontent'>Do you want to exit this Test Mode?</div>
                <div className='d-flex justify-content-center gap-2 mt-4'>
                  <div
                    className='nextprevbtn'
                    onClick={() => {
                      setShowConfirmationModal(false);
                    }}
                  >
                    Close
                  </div>
                  <div className='nextprevbtn' onClick={() => navigate(-1)}>
                    Yes
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
